"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderAvailability = void 0;
const react_1 = __importStar(require("react"));
const types_1 = require("@kyruus/types");
const AppointmentInfo_1 = require("./AppointmentInfo");
const Availability_1 = require("./Availability");
const utils_1 = require("./lib/utils");
const util_1 = require("../common/util");
const ProviderAvailability = ({ appointmentInfo, bookOnlineUrl, locations, loggingData, loggingFunction, maxAvailabilitiesToDisplay, onTimeSlotsClick, onViewMoreClick, provider, config, purposeOptionsByRelationship, selectedDate, services: { fetchAvailability, formatAvailability }, shouldRenderSlotsAsButtons, showRegulatedSpacesMessage = false, tileSize, bookSrc }) => {
    var _a, _b, _c, _d;
    const [availability, setAvailability] = (0, react_1.useState)({});
    const [selectedLocation, setSelectedLocation] = (0, react_1.useState)();
    const [slotsStatus, setSlotsStatus] = (0, react_1.useState)(undefined);
    const [viewMoreBookOnlineUrl, setViewMoreBookOnlineUrl] = (0, react_1.useState)(undefined);
    const log = (0, utils_1.getLogger)(loggingFunction, loggingData);
    const hidePatientRelationshipConfig = (_a = config === null || config === void 0 ? void 0 : config.direct_book) === null || _a === void 0 ? void 0 : _a.hide_patient_rel_for_locations;
    const shouldHaveSimilarPatientRelationshipQuestion = (_b = config === null || config === void 0 ? void 0 : config.darkship_feature_flags) === null || _b === void 0 ? void 0 : _b.enable_similar_exp_for_patient_relationship_question;
    const patientRelationshipOptions = (_d = (_c = config === null || config === void 0 ? void 0 : config.direct_book) === null || _c === void 0 ? void 0 : _c.patient_type) === null || _d === void 0 ? void 0 : _d.buttons;
    const hidePatientRelationshipQuestions = (0, utils_1.hidePatientRel)(provider, hidePatientRelationshipConfig);
    const handleLocationChange = (loc) => {
        setSelectedLocation(loc);
    };
    const resetAvailability = () => {
        setSlotsStatus(undefined);
        setAvailability({});
    };
    const handleUpdateAvailability = (newAppointmentInfo) => __awaiter(void 0, void 0, void 0, function* () {
        setSlotsStatus(types_1.PMCSlotStatuses.LOADING);
        const { slots, error } = yield fetchAvailability(provider.id, newAppointmentInfo);
        if (error) {
            setSlotsStatus(types_1.PMCSlotStatuses.ERROR);
            return;
        }
        if (slots) {
            const availabilityByLocationId = (0, utils_1.groupAvailabilityByLocationId)(slots);
            setAvailability(availabilityByLocationId);
        }
        const currentViewMoreBookOnlineUrl = (0, util_1.appendApptInfoToBookingUrl)(newAppointmentInfo, bookOnlineUrl);
        const currentViewMoreBookOnlineUrlWithTracking = (0, util_1.appendBookSrcToBookingUrl)(currentViewMoreBookOnlineUrl, bookSrc);
        setViewMoreBookOnlineUrl(currentViewMoreBookOnlineUrlWithTracking);
        setSlotsStatus(types_1.PMCSlotStatuses.SUCCESS);
    });
    (0, react_1.useEffect)(() => {
        if (appointmentInfo.purpose != null &&
            appointmentInfo.relationship != null) {
            const { relationship, purpose } = appointmentInfo;
            handleUpdateAvailability({ relationship, purpose });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const availabilityExists = (0, utils_1.locationsHaveAvailability)(availability, locations);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppointmentInfo_1.AppointmentInfo, { appointmentInfo: appointmentInfo, disableLocationFilter: !availabilityExists, handleUpdateAvailability: handleUpdateAvailability, locations: locations, config: config, provider: provider, hidePatientRelationshipQuestions: hidePatientRelationshipQuestions, patientRelationshipOptions: patientRelationshipOptions, shouldHaveSimilarPatientRelationshipQuestion: shouldHaveSimilarPatientRelationshipQuestion, log: log, onLocationChange: handleLocationChange, purposeOptionsByRelationship: purposeOptionsByRelationship, resetAvailability: resetAvailability, selectedLocation: selectedLocation }),
        slotsStatus != undefined && (react_1.default.createElement(Availability_1.AvailabilitySection, { availability: availability, locations: locations, maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay, provider: provider, selectedDate: selectedDate, selectedLocation: selectedLocation, shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons, slotsStatus: slotsStatus, tileSize: tileSize, onTimeSlotsClick: onTimeSlotsClick, bookOnlineUrl: bookOnlineUrl, viewMoreBookOnlineUrl: viewMoreBookOnlineUrl, onViewMoreClick: onViewMoreClick, formatAvailability: formatAvailability, log: log, showRegulatedSpacesMessage: showRegulatedSpacesMessage }))));
};
exports.ProviderAvailability = ProviderAvailability;
//# sourceMappingURL=ProviderAvailability.js.map